import { render } from "./BeneficiaryForm.vue?vue&type=template&id=631449a1&scoped=true"
import script from "./BeneficiaryForm.vue?vue&type=script&lang=js"
export * from "./BeneficiaryForm.vue?vue&type=script&lang=js"

import "./BeneficiaryForm.vue?vue&type=style&index=0&id=631449a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631449a1"]])

export default __exports__